<template>
	<div id="Main">
		<div class="content">
			<div class="titlebox">
				<p class="title">{{str.title}}</p>
				<van-row class="tisp" type="flex" justify="space-between">
					<van-col><van-icon class="icon" :name="require('../../assets/images/notice/time.png')" />{{str.publishtime_text.split(' ')[0]}}</van-col>
					<van-col><van-icon class="icon" :name="require('../../assets/images/notice/source.png')" />来源本站</van-col>
					<van-col><van-icon class="icon" :name="require('../../assets/images/notice/browse.png')" />{{str.views}}次浏览</van-col>
				</van-row>
			</div>
			<div class="htmlbox" v-html="str.content">
			</div>
			<van-button class="back" @click="back">返回列表</van-button>
		</div>
		<footerbox></footerbox>
	</div>
</template>
<script>
	import footerbox from '../../components/footer';
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {
			footerbox,
		},
		data() {
			return {
				str: {publishtime_text:''}, //添加默认值避免异步加载报错
				id:''
			}
		},
		methods: {
			back() {
				this.$router.go(-1);
			},
			getstr() { 
				axiosPost.getgetview({
					id: this.id
				}).then((res) => {
					if (res.data.code == 1) {
						this.str=res.data.data
					} else {
						this.$toast({duration:4000,message:res.data.msg});
					}
				}).catch(() => {

				})
			},
		},
		mounted() {
			this.id = this.$route.query.id
			this.getstr();
		},
	}
</script>

<style lang="scss" scoped>
	#Main {
		display: flex;
		flex-direction: column;
		min-height: 100vh;

		.content {
			flex: 1;
			padding-bottom: 8rem;
			position: relative;
			.back{
				background-color: #fa6b6b;
				color: #fff;
				position: absolute;
				right:1.3rem;
				bottom:3rem;
				line-height: 3rem;
				height: 3rem;
				border: 0;
				font-size: 1.3rem;
			}
			.titlebox {
				padding: 1.3rem;
				text-align: left;
				border-bottom: 1px solid #f2f2f2;
				.title {
					font-size: 1.9rem;
					color: #333333;
					margin-bottom: 1.5rem;
				}
				.tisp{
					font-size: 1.5rem;
					color:#999999;
					.icon{
						vertical-align: middle;
						margin-right: 0.3rem;
					}
				}
			}
			.htmlbox{
				font-size: 1.4rem;
				text-align: left;
				line-height: 2.4rem;
				padding: 1.3rem;
			}
		}
	}
</style>
